export enum FileExtension {
    XLSX = 'XLSX',
    XLS = 'XLS',
    CSV = 'CSV',
    XML = 'XML',
}
